import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { HttpclientService } from '../../services/httpclient.service';
import { Parentuseraccessdto } from '../../model/parentuseraccessdto';
import { Useraccess } from '../../model/useraccess';
import { Saveuseraccess} from '../../model/saveuseraccess';
import { Enablesaveuseraccessdto } from '../../model/enablesaveuseraccessdto';

@Component({
  selector: 'app-user-access',
  templateUrl: './user-access.component.html',
  styleUrls: ['./user-access.component.css']
})
export class UserAccessComponent implements OnInit {
  loading  : boolean;
  isChecked:number;
  useraccessobj : any=[];
  modalPopup : boolean =false;
  ids:any="";
  useraccesscheckorunckeck : any=[];
  tempArr: any = { "brands": [] };
  save : Enablesaveuseraccessdto;
  saving :string="";
  modalPopup1 : boolean = false;
  
  constructor(private httpclientService : HttpclientService,private router : Router) { 
    this.useraccess();
   
  }

  ngOnInit() {

    

  }
  pressingOK(){
    this.modalPopup=false;
    this.router.navigate(['dashboard']);
  }
  pressingCancel(){
    this.modalPopup=false;
  }
  
  useraccess(){
    this.loading = true;
    this.httpclientService.useraccesspage().subscribe(
      data =>{
        this.loading = false;
        this.useraccessobj = data;
        for(let i=0; i<this.useraccessobj.length; i++){
          let saveuseraccess = <Saveuseraccess> {};
          saveuseraccess.moduleid=this.useraccessobj[i].moduleId;
          saveuseraccess.axaltapartneradminmodenable=this.useraccessobj[i].isEnabledModuleList;
          
          // this.useraccesscheckorunckeck.push(saveuseraccess)
          this.useraccesscheckorunckeck[saveuseraccess.moduleid]=saveuseraccess;
           
        }
           
      }
    )
    
  }
  saveuseraccess(){
    console.log(this.isChecked);
     this.saving = "";
    this.loading = true;
    this.httpclientService.saveuseraccess(this.useraccesscheckorunckeck).subscribe(
      data =>{
       this.loading=false;
       this.save = data;
       this.modalPopup1=true
       this.saving = this.save.isSaved;

       this.useraccesscheckorunckeck.forEach(pdto => {
        pdto.editableFlag = 0;
      });

      }
    )
  }
  pressingOK1(){
    this.saving="";
    this.modalPopup1=false;
  }
  canceluseraccess(){
    this.saving="";
    this.modalPopup=true;
   
  }

  toggleVisibility(event){
  //  this.saving="";
   this.ids= event.target.id;
    let moduleidandadpartneraxalta = this.ids.split("_");
    let moduleid =  moduleidandadpartneraxalta[0];
    let adminpartneraxaltaid = moduleidandadpartneraxalta[1];
    console.log("moduleid : "+moduleid);
    console.log("adminpartneraxaltaid : "+adminpartneraxaltaid);


    console.log(event.target.checked);
    console.log(this.useraccesscheckorunckeck);
    
    //let num = +moduleid;
    // num=num-1;
      console.log(this.useraccesscheckorunckeck[moduleid] );
      this.useraccesscheckorunckeck[moduleid].moduleid;
    
    let axapartadmin=+adminpartneraxaltaid;
    axapartadmin=axapartadmin-1;
    this.useraccesscheckorunckeck[moduleid].axaltapartneradminmodenable[axapartadmin];
      
      
 
   if(event.target.checked == true){
        this.useraccesscheckorunckeck[moduleid].axaltapartneradminmodenable[axapartadmin]=1;
        this.useraccesscheckorunckeck[moduleid].editableFlag = 1;

      }else{
        this.useraccesscheckorunckeck[moduleid].axaltapartneradminmodenable[axapartadmin]=0;
        this.useraccesscheckorunckeck[moduleid].editableFlag = 1;
      }

      console.log( "...editFlag..."+this.useraccesscheckorunckeck[moduleid].editableFlag );
    
      this.ids="";
      
  }
}
